import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { PollyManageDataService } from '../polly-manage-data-service/polly-manage-data.service';
import { License, LicenseBasedAppList, UserResponse } from 'polly-commons';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { PollyManageBackendService } from '../polly-manage-backend-service/polly-manage-backend.service';

@Injectable({
  providedIn: 'root'
})
export class PollyManageLicenseBasedAppRouteGuardService  {

  constructor(
    private readonly router: Router,
    private readonly manageDataService: PollyManageDataService,
    private readonly pollyManageBackendService: PollyManageBackendService
  ) { }
  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const appName: LicenseBasedAppList = route.data.appName;
    const currentUserLicenseInfo: License | null = this.manageDataService.getCurrentUserLicenseInfo();
    if (currentUserLicenseInfo) {
      const isAppAvailable: boolean = this.manageDataService.isAppAvailable(appName);
      if (isAppAvailable) {
        return of(true);
      } else {
        this.router.navigate(['manage/atlas'], { replaceUrl: true});
        return of(false);
      }
    }
    return this.pollyManageBackendService.getCurrentUserInfo().pipe(
      map((userInfo: UserResponse) => {
        this.manageDataService.userInfo = userInfo;
        this.manageDataService.currentUserInfo = userInfo.data;
        if (userInfo.included && userInfo.included.length) {
          const orgInfo = userInfo.included.find(item => item.type === 'organizations');
          if (orgInfo) {
            this.manageDataService.currentUserOrganization = {
              org_id: Number(orgInfo.id),
              org_name: orgInfo.attributes.name
            };
          }
          const licenseInfo = userInfo.included.find(item => item.type === 'licenses');
          if (licenseInfo) {
            this.manageDataService.currentUserLicenseInfo = licenseInfo;
            if (this.manageDataService.isAppAvailable(appName)) {
              return true;
            } else {
              this.router.navigate(['manage/atlas'], { replaceUrl: true});
               return false;
            }
          }
        }
        return false;
      })
    );
  }
}
